import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z","key":"svg-0"}],["path",{"d":"M3 11l8 -8","key":"svg-1"}],["path",{"d":"M3 17l14 -14","key":"svg-2"}]]

const IconWashDryShade = createReactComponent('outline', 'wash-dry-shade', 'WashDryShade', __iconNode);

export default IconWashDryShade;